/**
 * P1 Apex Urgency Features
 * - ViewerCounter: Simuleret "X kigger på denne" på produktsider
 * - PurchaseToast: Simuleret "Nyligt købt" popup (én gang per sidevisning)
 */

(function() {
  'use strict';

  // Undgå dobbelt initialisering
  if (window.P1ApexUrgencyInitialized) return;
  window.P1ApexUrgencyInitialized = true;

  // Utility funktioner
  const Utils = {
    random: (min, max) => Math.floor(Math.random() * (max - min + 1)) + min,

    isPeakHours: () => {
      const hour = new Date().getHours();
      return hour >= 17 && hour <= 21;
    },

    getSessionData: (key, defaultValue) => {
      try {
        const data = sessionStorage.getItem(key);
        return data ? JSON.parse(data) : defaultValue;
      } catch (e) {
        return defaultValue;
      }
    },

    setSessionData: (key, value) => {
      try {
        sessionStorage.setItem(key, JSON.stringify(value));
      } catch (e) {
        // SessionStorage ikke tilgængelig
      }
    }
  };

  /**
   * Viewer Counter - "X personer kigger på denne oplevelse lige nu"
   */
  class ViewerCounter {
    constructor() {
      this.element = document.getElementById('viewer-counter');
      this.countElement = document.getElementById('viewer-count');
      this.sessionKey = 'p1apex_viewer_count';
      this.updateInterval = null;

      if (this.element && this.countElement) {
        this.init();
      }
    }

    init() {
      // Hent eller generer initial count
      let count = Utils.getSessionData(this.sessionKey, null);

      if (count === null) {
        count = this.generateInitialCount();
        Utils.setSessionData(this.sessionKey, count);
      }

      this.updateDisplay(count);
      this.element.style.display = 'flex';

      // Start interval for at opdatere count
      this.startUpdateInterval();
    }

    generateInitialCount() {
      // Base: 3-8 personer
      let count = Utils.random(3, 8);

      // Peak hours boost: +3-5
      if (Utils.isPeakHours()) {
        count += Utils.random(3, 5);
      }

      return count;
    }

    updateDisplay(count) {
      // Minimum 2, maksimum 25
      count = Math.max(2, Math.min(25, count));
      this.countElement.textContent = count;
      Utils.setSessionData(this.sessionKey, count);
    }

    startUpdateInterval() {
      // Opdater hvert 30-60 sekunder
      const scheduleUpdate = () => {
        const delay = Utils.random(30000, 60000);
        this.updateInterval = setTimeout(() => {
          this.fluctuateCount();
          scheduleUpdate();
        }, delay);
      };

      scheduleUpdate();
    }

    fluctuateCount() {
      let count = Utils.getSessionData(this.sessionKey, 5);

      // +/- 1-2 variation
      const change = Utils.random(-2, 2);
      count += change;

      // Hold inden for rimelige grænser
      count = Math.max(2, Math.min(20, count));

      this.updateDisplay(count);
    }

    destroy() {
      if (this.updateInterval) {
        clearTimeout(this.updateInterval);
      }
    }
  }

  /**
   * Purchase Toast - "Martin købte [produkt] for X min siden"
   * Vises kun én gang per sidevisning på produktsider
   */
  class PurchaseToast {
    constructor() {
      this.element = document.getElementById('purchase-toast');
      this.nameElement = document.getElementById('purchase-toast-name');
      this.productElement = document.getElementById('purchase-toast-product');
      this.timeElement = document.getElementById('purchase-toast-time');
      this.closeButton = document.getElementById('purchase-toast-close');

      this.config = window.PurchaseToastConfig || {
        names: ['Martin', 'Thomas', 'Anne', 'Louise'],
        currentProduct: null
      };

      this.showTimeout = null;
      this.hideTimeout = null;
      this.hasShown = false;

      if (this.element && this.config.currentProduct) {
        this.init();
      }
    }

    init() {
      // Setup close button
      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.hide());
      }

      // Vis toast efter 5 sekunder
      this.showTimeout = setTimeout(() => this.showToast(), 5000);
    }

    getRandomName() {
      const names = this.config.names;
      return names[Utils.random(0, names.length - 1)];
    }

    getRandomTime() {
      // 5-45 minutter siden
      const minutes = Utils.random(5, 45);
      if (minutes === 1) {
        return 'for 1 minut siden';
      }
      return `for ${minutes} minutter siden`;
    }

    showToast() {
      // Kun vis én gang
      if (this.hasShown) return;
      this.hasShown = true;

      // Opdater indhold
      const name = this.getRandomName();
      const product = this.config.currentProduct;
      const time = this.getRandomTime();

      this.nameElement.textContent = name;
      this.productElement.textContent = `købte ${product}`;
      this.timeElement.textContent = time;

      // Vis toast
      this.element.style.display = 'flex';

      // Trigger animation efter en frame
      requestAnimationFrame(() => {
        this.element.classList.remove('hiding');
        this.element.classList.add('visible');
      });

      // Skjul efter 10 sekunder
      this.hideTimeout = setTimeout(() => {
        this.hide();
      }, 10000);
    }

    hide() {
      this.element.classList.remove('visible');
      this.element.classList.add('hiding');

      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
        this.hideTimeout = null;
      }
    }

    destroy() {
      if (this.showTimeout) clearTimeout(this.showTimeout);
      if (this.hideTimeout) clearTimeout(this.hideTimeout);
    }
  }

  // Initialiser når DOM er klar
  function init() {
    // ViewerCounter - kun på produktsider
    if (document.getElementById('viewer-counter')) {
      window.p1apexViewerCounter = new ViewerCounter();
    }

    // PurchaseToast - kun på produktsider (hvor currentProduct er sat)
    if (document.getElementById('purchase-toast')) {
      window.p1apexPurchaseToast = new PurchaseToast();
    }
  }

  // Start
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
